/**
 * Role enumerator
 */
import {Tenant} from "./tenant.model";
import {Customer} from "./customer.model";

export enum Role {
  JujoAdmin = 'JujoAdmin',
  CustomerAdmin = 'CustomerAdmin',
  TenantAdmin = 'TenantAdmin',
  Reviewer = 'Reviewer',

}

/**
 * Session object
 */
export class Session {
  token: string;
  accountGuid: string;
  startDt: number;
  lastActivityDt: number;
  expiresIn: number;
  statusCd: string;
  userAgent: string;
  ipAddress: string;
  executionId: string;
  tenants: Tenant[];
  customers: Customer[];
}
